import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interpreting-results',
  templateUrl: './interpreting-results.component.html',
  styleUrls: ['./interpreting-results.component.scss']
})
export class InterpretingResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
